/**
 *
 * Subscribe
 *
 * Handles the events for subscribing to the Iterable
 */

const $         = require( 'jQuery' );
const _model    = require( './utilities/_model.js' );
const _Forms   = require( './utilities/_form-controller' );
const Deckable2 = require( './utilities/deckable2' );
const _ = require("lodash");
const Form_init = require("./src/Form_init");

const { Foundation, TimelineMax } = window;

var BlogSub = function(el){

    //setup some variables
    this.$el                = $(el);
    this.$form              = this.$el.find( '.itbl-c-form-blog-subscribe' );
    this.$succcessWrap      = this.$el.find( '.itbl-subscribe__success' );
    this.$svgWrap            = this.$el.find( '#itbl-b-confirmation__blog' );
    this.$svg               = this.$el.find( '.itbl-b-confirmation__svg' );
    this.$subscribeSuccess  = this.$el.find( '.itbl-blog-subscribe__success-content' );

    this.FormInstance       = new Foundation.Abide( this.$form );

    this.APIState         = {
        wp_email_to     : 'forms@iterable.com',
        wp_email_message: null, //we gotta build this message body
        wp_email_subject: 'New User Subscribes to Blog'
    };


    this.init();
};

BlogSub.prototype.init = function(){


    //events
    this.$form
        .on( 'submit', _Forms.event__PreventDefault )
        .on( 'forminvalid.zf.abide', _Forms.event__PreventDefault )
        .on( 'formvalid.zf.abide', this.event__validForm.bind(this) );


    Form_init(this.$form[0]);

};

BlogSub.prototype.event__validForm = function( event, frm ){

    //disable normal submit event
    event.preventDefault();

    $(this.$form).addClass( 'itbl-u-faded' );

    _Forms.helper__addFormInputsToState( frm, this.APIState );

    _Forms.marketo__submit( this.APIState, undefined, undefined, this.$form )
        .catch( (e)=>{

            console.log( e );

            //change the success message to a failure
            $(this.$svgWrap).html('<span class="fas fa-exclamation-circle itbl-c-form__error-icon itbl-u-font-size-xxxl"></span>\n');
            $(this.$subscribeSuccess).text( 'Looks like we had some trouble adding your email address, we will be in touch soon to confirm that you\'ve been added.' );
            var success = new TimelineMax()
                .set( this.$succcessWrap, {className:"+=animated"} )
                .set( this.$succcessWrap, {className: "+=flipInX"} );

            //then create the email message body
            var html =  $('<div />')
                .append([
                    $('<p />').text( `We had some issues subscribing ${this.APIState.Email} to the Iterable blog` ),

                ]);

            const subject = `Form Submission Failure => Form: ${_.findKey(window.ITBL.itbl_marketo, x => x == this.APIState.formid)}, Email: ${this.APIState.Email}, Form ID: ${this.APIState.formid}`;
            _model.model__handleEmailSubmission(subject, JSON.stringify(this.APIState, null, 4));

        })
        .finally(()=>{

            //shows the success message
            this.view__showSuccess();

        });

    //just to be sure
    return false;

};

BlogSub.prototype.view__showSuccess = function(){

    var success = new TimelineMax()
        .set( this.$succcessWrap, {className:"+=animated"} )
        .set( this.$succcessWrap, {className: "+=flipInX"})
        .set( this.$svg, {className:"-=itbl-e-hide"}, "+=1")
        .set( this.$svg, {className:"+=animated"} )
        .set( this.$svg, {className: "+=heartBeat"} );



};


$(document).ready(function(){
    $('.js-init-subscribe').each(function(){
        new BlogSub(this);
    });

});

/**
 *
 * Subscribe Block
 *
 * Handles the events for subscribing to the Iterable for the subscribe Gutenberg Block
 */

class Block_blogSub{

    constructor(el){

        this.$el = $(el);
        this.$form              = this.$el.find( '.itbl-c-form-blog-subscribe' );
        this.$succcessWrap      = this.$el.find( '.itbl-subscribe__success' );
        this.$svgWrap           = this.$el.find( '#itbl-b-confirmation__blog' );
        this.$svg               = this.$el.find( '.itbl-b-confirmation__svg' );
        this.$subscribeSuccess  = this.$el.find( '.itbl-blog-subscribe__success-content' );
        
        this.FormInstance       = new Foundation.Abide( this.$form );

        this.APIState         = {
            wp_email_to     : 'forms@iterable.com',
            wp_email_message: null, //we gotta build this message body
            wp_email_subject: 'New User Subscribes to Blog'
        };

        //init the deckable class and turn on the loading spinner
        this.deckable = new Deckable2(this.$el, {})
            .showHideLoading(true);

        this.deckable
            .goToDeck('form');

        this.events();

    }

    events(){

        //events
        this.$form
            .on( 'submit', _Forms.event__PreventDefault )
            .on( 'forminvalid.zf.abide', _Forms.event__PreventDefault )
            .on( 'formvalid.zf.abide', this.event__validForm.bind(this) );

        Form_init(this.$form[0]);

        this.deckable.$el.on( 'deckable/animateIn/success', ()=>{

            var success = new TimelineMax()
                .set( this.$svg, {className:"-=itbl-e-hide"})
                .set( this.$svg, {className:"+=animated"} )
                .set( this.$svg, {className: "+=heartBeat"} );
            } );
    }

    event__validForm( event, frm ){

        //disable normal submit event
        event.preventDefault();

        _Forms.helper__addFormInputsToState( frm, this.APIState );

        _model.model__handleEmailSubmission(`Form Submission => Form: ${_.findKey(window.ITBL.itbl_marketo, x => x == this.APIState.formid)}, Email: ${this.APIState.Email}, Form ID: ${this.APIState.formid}`, JSON.stringify(this.APIState, null, 4));

        _Forms.marketo__submit( this.APIState, undefined, undefined, this.$form )
            .catch( (e)=>{

                console.log( e );

                //then create the email message body
                var html =  $('<div />')
                    .append([
                        $('<p />').text( `We had some issues subscribing ${this.APIState.Email} to the Iterable blog` ),

                    ]);

                const subject = `Form Submission Failure => Form: ${_.findKey(window.ITBL.itbl_marketo, x => x == this.APIState.formid)}, Email: ${this.APIState.Email}, Form ID: ${this.APIState.formid}`;
                _model.model__handleEmailSubmission(subject, JSON.stringify(this.APIState, null, 4));

            })
            .finally(()=>{

                this.deckable.goToDeck( 'success');

            });

        //just to be sure
        return false;

    }



}

$(document).ready(function(){
    $('.js-subscribe-block-init').each(function(){
        new Block_blogSub(this);
    });

});
